import { Directive, Input, TemplateRef, ViewContainerRef, OnInit, OnDestroy } from '@angular/core';
import { PermissionService } from '@core/services/permission.service';

@Directive({
  standalone: false,
  selector: '[appHasPermission]'
})
export class HasPermissionDirective implements OnInit, OnDestroy {

  private module = '';
  private action: 'view' | 'add' | 'edit' | 'delete' = 'view';
  private hasView = false;

  @Input() set appHasPermission(value: string) {
    const parts = value.split(':');
    this.module = parts[0] || '';
    this.action = (parts[1] as any) || 'view';
    this.updateView();
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionService: PermissionService
  ) {}

  ngOnInit(): void {
    this.updateView();
  }

  ngOnDestroy(): void {
    this.viewContainer.clear();
  }

  private updateView(): void {
    const allowed = this.checkPermission();
    if (allowed && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!allowed && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }

  private checkPermission(): boolean {
    if (!this.module) return false;
    switch (this.action) {
      case 'view':   return this.permissionService.canViewModule(this.module);
      case 'add':    return this.permissionService.canAddInModule(this.module);
      case 'edit':   return this.permissionService.canEditInModule(this.module);
      case 'delete': return this.permissionService.canDeleteInModule(this.module);
      default:       return false;
    }
  }
}
